import { Injectable } from '@angular/core';
import { CacheService } from '@df/core/cache/cache';
import { NDfs } from '../../dfs.interfaces';
import { dfsDimension2String } from '../../util/dfs-dimension-2-string';
import { dfsString2Dimension } from '../../util/dfs-string-2-dimension';
import { DfsGlobalsService } from './../../core/dfs-globals.service';

@Injectable({
    providedIn: 'any'
})
export class DfsDimensionsParserService implements NDfs.IParser {
    /**
     * Dependencies
     */
    constructor(private cacheService: CacheService) {}

    /**
     * Parse styles string like:     *
     * 1, 2, ..., 4px, -1g, 2c+2px, 100%
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        return this.cacheService.get<NDfs.ICssEntry[]>(['dfs', 'dimensionsParser', dfs, rule.prop], () => [
            {
                prop: rule.prop,
                value: this.cacheService.get<string>(['dfs', 'dimensionsParserValue', dfs, rule.parserOptions], () => {
                    let multiple = false;
                    const parts = dfs.split('+').map(i => {
                        const partsMinus = dfs.split('-');
                        if (partsMinus.length > 1) {
                            if (partsMinus.length === 2 && !partsMinus[0]) {
                                return dfsDimension2String(dfsString2Dimension(i));
                            }
                            multiple = true;
                        }
                        return partsMinus.map(j => dfsDimension2String(dfsString2Dimension(j))).join(' - ');
                    });
                    if (parts.length > 1) {
                        multiple = true;
                    }

                    const combined = parts.join(' + ');
                    const value = !multiple && !combined.includes('--') ? combined : `calc(${combined})`;
                    return rule.parserOptions?.transform ? rule.parserOptions.transform(value) : value;
                })!
            }
        ])!;
    }
}
